import { Button } from "@hatch-digital-nl/abs-storybook/legacy";
import { JSX } from "react";

interface Props {
    isPatchEditCertificateLoading: boolean;
}

export const SubmitButtonComponent = (props: Props): JSX.Element => {
    const { isPatchEditCertificateLoading } = props;

    return (
        <div
            className={
                "c-edit-certificate-modal__form-group c-edit-certificate-modal__form-group--button"
            }
        >
            <Button
                loading={isPatchEditCertificateLoading}
                disabled={isPatchEditCertificateLoading}
                variant={"primary"}
                type={"submit"}
            >
                Certificaat bewerken
            </Button>
        </div>
    );
};
